export enum PolicyHolderRelationship {
  SELF = 'Self',
  SPOUSE = 'Spouse',
  PARENT = 'Parent',
  MY_CHILD = 'Child',
  OTHER = 'Other Adult',
}

export enum InsuranceSex {
  MALE = 'Male',
  FEMALE = 'Female',
  NON_BINARY = 'Non-binary',
}
